import { render, staticRenderFns } from "./objectCard.vue?vue&type=template&id=4240c835&"
import script from "./objectCard.vue?vue&type=script&lang=js&"
export * from "./objectCard.vue?vue&type=script&lang=js&"
import style0 from "./objectCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports